<template>
  <v-card>
    <v-toolbar dense elevation="1">
      <v-spacer />
      <v-toolbar-title>
        ユニット編集
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="clearAll" v-on="on"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              v-model="selectedUnit.name"
              item-text="name"
              label="ユニット名"
              prepend-icon="mdi-orbit"
              autofocus
              chips
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model="selectedDevices"
              :items="devices"
              prepend-icon="mdi-camera"
              label="登録するデバイス"
              item-text="name"
              return-object
              multiple
            >
              <template v-slot:item="{ item, attrs }">
                <v-list-item-action>
                  <v-checkbox :input-value="attrs.inputValue" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <span class="text-caption grey--text mr-2">
                      デバイス
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="red" outlined @click="deleteUnit" disabled>
        ユニットを削除
        <v-icon right>mdi-delete</v-icon>
      </v-btn>
      <v-btn color="success" outlined @click="saveEdited">
        変更を保存
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { deviceFunctionsMixin } from '@/plugins/mixins'
import { uniq } from 'lodash/array'
import { updateDeviceUnit } from '@/firebaseAccess/firestoreAccess'

export default {
  name: 'DeviceUnitEditDialog',
  mixins: [deviceFunctionsMixin],
  props: {
    selectedDevice: {
      type: Object,
      required: true
    },
    selectedUnit: {
      type: Object,
      required: true
    },
    devices: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    selectedDevices: []
  }),
  methods: {
    saveEdited() {
      this.saveUnit()
      this.updateDevice()
    },
    clearDraftUnit() {
      this.selectedDevices = []
    },
    clearAll() {
      this.$emit('clickClear')
      this.clearDraftUnit()
    },
    saveUnit() {
      updateDeviceUnit(this.selectedUnit.id, this.selectedUnit, true)
      this.clearAll()
    },
    deleteUnit() {
      // delete unit from all devices and group lists
      for (const device of this.devices) {
        device.units = device.units.filter(d => d !== this.selectedUnit.id)
        this.$emit('updateDevice', device)
      }
      this.clearDraftUnit()
    },
    setSelectedDevices() {
      this.selectedDevices = this.devices.filter(d =>
        d.units.some(u => u === this.selectedUnit.id)
      )
    },
    updateDevice() {
      for (const device of this.selectedDevices) {
        // push does not work, duplicate array
        device.units = uniq(device.units.concat([this.selectedUnit.id]))
        this.$emit('updateDevice', device)
      }
    }
  },
  mounted() {
    this.setSelectedDevices()
  },
  watch: {
    selectedUnit() {
      this.setSelectedDevices()
    }
  }
}
</script>
